module.exports = __webpack_public_path__ + "static/media/icon-notification.7ba601ae.svg";